export default "__VITE_ASSET__mBd$7AYq__"